import {
  DOCS_BASE_PATH,
  DOCS_DEFAULT_PATH,
} from "../../pages/docs/config/docConstants";

/** Same remaps as Sidebar pageToNavPageMap where Help should follow nav intent */
const PAGE_NAME_ALIASES = {
  "Testrun Details": "Test Runs",
};

export const PAGE_NAME_TO_DOCS_ROUTE = {
  Projects: "org-project",
  "Test Cases": "test-cases-modules",
  "Test Groups": "test-runs-execution",
  "Test Runs": "test-runs-execution",
  "Automation Studio": "automation-studio-guide",
  "Variables & Environment": "variables-environments",
  "AI Generator": "ai-generator",
  "Project Team": "team-management",
  "File Manager": "file-manager",
};

export function getDocsHelpPath(activePage) {
  const normalized = PAGE_NAME_ALIASES[activePage] ?? activePage;
  const docsRoute = PAGE_NAME_TO_DOCS_ROUTE[normalized];
  return docsRoute ? `${DOCS_BASE_PATH}/${docsRoute}` : DOCS_DEFAULT_PATH;
}
